import {UseFormReturnType} from "@mantine/form";
import {useTranslation} from "react-i18next";
import {Button, Divider, Grid, Radio, Stack, Textarea} from "@mantine/core";
import {useCallback} from "react";
import {useDVIRReviewForm} from "./useDVIRReviewForm";

export interface DVIRReviewFormProps {
  options?: DVIRReviewFormOptions;
  defaultValues?: DVIRReviewFormDefaultValues;
  onSubmit?: (values: DVIRReviewFormValues) => void;
  submitting?: boolean;
}

export interface DVIRReviewFormOptions {

}

export interface DVIRReviewFormValues {
  defectsCorrected: boolean,
  defectsNeedNotCorrected: boolean,
  comments?: string;
}

export interface DVIRReviewFormDefaultValues extends Partial<DVIRReviewFormValues> {

}

export interface DVIRReviewFormRawValues {
  defects: "corrected" | "not_needed",
  comments?: string;
}

export type DVIRReviewFormType = UseFormReturnType<DVIRReviewFormRawValues, (values: DVIRReviewFormRawValues) => DVIRReviewFormRawValues>

export const DVIRReviewForm = (props: DVIRReviewFormProps) => {
  const {
    options,
    defaultValues,
    onSubmit,
    submitting = false
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useDVIRReviewForm({
    defaultValues: defaultValues,
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {
    if (onSubmit) {
      onSubmit({
        defectsCorrected: values.defects === "corrected",
        defectsNeedNotCorrected: values.defects === "not_needed",
        comments: values.comments,
      });
    }
  }, [form, onSubmit]);

  return (
    <form onSubmit={form.onSubmit(onFormSubmit)}>
      <Grid grow gutter="xs">
        <Grid.Col span={12}>
          <Radio.Group
            {...form.getInputProps("defects", {type: 'checkbox'})}
            name="defects"
            withAsterisk={true}
            required={true}>
            <Stack mt="xs">
              <Radio value="corrected" label={"Defects Corrected"}/>
              <Radio value="not_needed" label={"Defects Need Not Corrected"}/>
            </Stack>
          </Radio.Group>
        </Grid.Col>
      </Grid>
      <Divider my="sm" variant="dotted"/>
      <Textarea
        label={t("common.entity.dvir.form.field.comments", "Comments")}
        placeholder={t<string>("common.entity.dvir.form.field.comments.placeholder", "Comment")}
        maxLength={2000}
        autosize
        minRows={6}
        required={true}
        withAsterisk={true}
        {...form.getInputProps("comments")} />
      <Button type="submit" loading={submitting} fullWidth mt="xl">
        {t("common.action.submit", {ns: "common"})}
      </Button>
    </form>
  );
};
